import React from 'react';

/**
 * 48px tall, 16px text: comfortable to tap, and iOS will not zoom the
 * viewport on focus. Placeholders never carry meaning a label should.
 */
export const inputClasses = 'min-h-touch-lg w-full rounded-lg border border-line-strong bg-surface px-3.5 py-2.5 text-body text-ink placeholder:text-ink-subtle transition-colors duration-150 ease-out hover:border-ink-subtle focus:border-brand-700 focus:ring-2 focus:ring-brand-200 focus:outline-none';
export const selectClasses = `${inputClasses} appearance-none bg-[length:16px] bg-[right_0.65rem_center] bg-no-repeat pr-9`;
interface FieldProps {
  label: string;
  hint?: string;
  htmlFor?: string;
  children: React.ReactNode;
}
export function Field({
  label,
  hint,
  htmlFor,
  children
}: FieldProps) {
  return <div className="min-w-0" data-id="element-5224" data-mp="mupgrne3nsxw">
      <label htmlFor={htmlFor} className="mb-1.5 block text-body-sm font-medium text-ink" data-id="element-5225" data-mp="rsqvxx8en843">
        {label}
      </label>
      {children}
      {hint && <p className="mt-1.5 text-body-sm text-ink-muted" data-id="element-5226" data-mp="ybfx3i46t3hq">{hint}</p>}
    </div>;
}
export function Select({
  className,
  children,
  ...props
}: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <select className={`${selectClasses} ${className ?? ''}`} style={{
    backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%235b6a7d' stroke-width='1.5'%3E%3Cpath d='M4 6l4 4 4-4'/%3E%3C/svg%3E\")"
  }} {...props} data-id="element-5227" data-mp="od9t8uytlna8">
      {children}
    </select>;
}
export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(function Input({
  className,
  ...rest
}, ref) {
  return <input ref={ref} className={`${inputClasses} ${className ?? ''}`} {...rest} data-id="element-5228" data-mp="13bbz5btbqkun" />;
});
export function Textarea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const {
    className,
    ...rest
  } = props;
  return <textarea className={`w-full rounded-lg border border-line-strong bg-surface px-3.5 py-2.5 text-body text-ink placeholder:text-ink-subtle transition-colors duration-150 ease-out hover:border-ink-subtle focus:border-brand-700 focus:ring-2 focus:ring-brand-200 focus:outline-none ${className ?? ''}`} {...rest} data-id="element-5229" data-mp="1v05gxdzdk66c" />;
}